import crudActions from '../crud/actions'

const actions = crudActions('RISKASSESSMENTTEMPLATE_')

export default actions
